import { deriveImageOrigins } from '@vs-shop/engine/image/imageOrigins';

// The image origins this rcprofi build serves from. `next.config.ts` turns them
// into `images.remotePatterns` and `src/next/VsImage.tsx` into bypass rules, so
// the two lists cannot disagree. The derivation and its reasons live in
// `@vs-shop/engine/image/imageOrigins`.
//
// The `process.env.NEXT_PUBLIC_*` reads are literal on purpose: Next inlines
// them at build time and does not inline a computed lookup.
//
// `next.config.ts` loads this module before any bundler exists; see
// `./nextjs.ts` for what that allows it to import.
export const imageOrigins = deriveImageOrigins({
  cdnUrl: process.env.NEXT_PUBLIC_GCS_PUBLIC_URL,
  apiEntrypoint: process.env.NEXT_PUBLIC_API_ENTRYPOINT,
});
